/* eslint-disable react/require-default-props */
// eslint-disable-next-line
import React, { FC, ComponentType } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { selectLoggedUser, selectUserEntity } from 'store/modules/auth';
import { useUserRole } from 'core/auth/hooks';
import { useSelector } from 'react-redux';
import { BusinessName } from 'core/entities';
import { Roles } from './user.model';

type PrivateRouteEntitiesProps = {
  component: ComponentType<any>;
  requiredRoles?: Roles[];
  redirectPath?: string;
  requiredBusiness?: BusinessName[];
} & RouteProps;

const PrivateRouteEntities: FC<PrivateRouteEntitiesProps> = ({
  component: Component,
  requiredRoles = [],
  redirectPath = '/login',
  requiredBusiness = [],
  ...rest
}) => {
  const selectedEntity = useSelector(selectUserEntity);
  const user = useSelector(selectLoggedUser);
  const isAuthorizedByRol = useUserRole(requiredRoles);
  const businessPermission =
    requiredBusiness.length > 0 &&
    selectedEntity &&
    selectedEntity.business &&
    requiredBusiness.includes(selectedEntity.business);

  let showRoute = false;
  if (requiredBusiness.length > 0 && requiredRoles.length === 0) {
    showRoute = !!(user && !!businessPermission);
  } else if (requiredBusiness.length === 0 && requiredRoles.length > 0) {
    showRoute = !!(user && isAuthorizedByRol);
  } else {
    showRoute = !!(user && !!businessPermission && isAuthorizedByRol);
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        showRoute ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRouteEntities;
